import type { Observable } from 'rxjs';

import { useBackendHttpService } from '../../http';
import type { OrganizationCompactDto, UserDto } from '../domain';
import type { CreateUserPayload, EditUserPayload, TemplateDto } from './bookkeeper.domain';

const API = '/s/bookkeeper/v1';

//TODO: clean / replace by fetchOrganizations in organization.api.ts
export function fetchBookkeeperOrganizations(): Observable<OrganizationCompactDto[]> {
	const { http } = useBackendHttpService();
	return http.get(`${API}/organizations`);
}

export function fetchBookkeeperTemplates(): Observable<TemplateDto[]> {
	const { http } = useBackendHttpService();
	return http.get(`${API}/templates`);
}

//TODO: simplify url
export function fetchProfile(): Observable<UserDto> {
	const { http } = useBackendHttpService();
	return http.get(`${API}/console-users/profile`);
}

export function fetchCollaborators(): Observable<UserDto[]> {
	const { http } = useBackendHttpService();
	return http.get(`${API}/console-users`);
}

export function createCollaborator(user: CreateUserPayload): Observable<UserDto> {
	const { http } = useBackendHttpService();
	return http.post(`${API}/console-users`, user);
}

export function editCollaborator(user: EditUserPayload): Observable<UserDto> {
	const { http } = useBackendHttpService();
	return http.put(`${API}/console-users/${user.id}`, user);
}

export function resendCollaboratorInvitation(userId: string): Observable<void> {
	const { http } = useBackendHttpService();
	return http.post(`${API}/console-users/${userId}/resend-invitation`);
}
